import 'zone.js';
import { enableProdMode, isDevMode } from '@angular/core';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

!isDevMode() && enableProdMode();

platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.error(err));


// if (environment.production) { enableProdMode(); }


// (async () => {
//   if (isDevMode()) {
//     // JIT
//     const { platformBrowserDynamic } = await import('@angular/platform-browser-dynamic');
//     platformBrowserDynamic()
//       .bootstrapModule(AppModule)
//       .catch(err => console.error(err));
//   } else {
//     // AOT
//     const { platformBrowser } = await import('@angular/platform-browser');
//     platformBrowser()
//       .bootstrapModule(AppModule)
//       .catch(err => console.error(err));
//   }
// })();
